import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo"
import PageHeaderTitle from "../components/PageHeaderTitle/PageHeaderTitle"
import CommonSeoPage from "../components/CommonSeoPage/CommonSeoPage"
import { Link } from "gatsby"

const GuidePage = () => (
  <Layout>
    <SEO title="Przegląd okresowy budynków" ratingCount={20} ratingValue={4.78} />
    <PageHeaderTitle text="Przegląd okresowy budynków" />
    <CommonSeoPage>
      <h2>Co to jest przegląd okresowy budynków?</h2>
      <p>
        Przegląd okresowy budynków to obowiązkowa kontrola stanu technicznego
        budynków i ich elementów przeprowadzana przez uprawnione osoby lub firmy
        co pewien okres czasu. Jest to procedura, która ma na celu zapewnienie
        bezpieczeństwa użytkowników budynków oraz zapobieganie awariom i
        uszkodzeniom budynków.
      </p>
      <h2>Dlaczego przegląd okresowy budynków jest tak istotny?</h2>
      <p>
        Przegląd okresowy budynków jest bardzo ważny z wielu powodów. Po
        pierwsze, zapobiega to awariom i uszkodzeniom budynków, co może
        spowodować niebezpieczeństwo dla użytkowników. Po drugie, umożliwia
        wykrycie i naprawę usterek w początkowej fazie, co minimalizuje koszty
        napraw w przyszłości. Po trzecie, przegląd okresowy budynków jest
        wymagany przez prawo budowlane i brak przeprowadzenia go w odpowiednim
        czasie może skutkować sankcjami finansowymi.
      </p>
      <h2>Jak wygląda przegląd okresowy budynków i na czym polega?</h2>
      <p>
        Podczas przeglądu okresowego budynku, inspektor dokonuje szczegółowej
        oceny stanu technicznego budynku oraz jego elementów konstrukcyjnych,
        instalacji i urządzeń technicznych. W ramach przeglądu oceniana jest
        również dokumentacja budowlana i eksploatacyjna budynku. Inspektor
        dokonuje wizualnej oceny budynku oraz stosuje odpowiednie narzędzia
        pomiarowe, które pozwalają na wykrycie ewentualnych usterek i uszkodzeń.
        W przypadku stwierdzenia nieprawidłowości, inspektor sporządza
        szczegółową dokumentację, w której opisuje zauważone problemy i
        proponuje sposoby ich naprawy. Przegląd okresowy budynków jest niezbędny
        dla zapewnienia bezpieczeństwa osób przebywających w budynku oraz
        przedłużenia jego żywotności.
      </p>
      <h2>Jakie korzyści płyną z wykonania przeglądu okresowego budynków?</h2>
      <p>
        Wykonanie przeglądu okresowego budynków przynosi wiele korzyści. Przede
        wszystkim, umożliwia wykrycie i naprawę usterek w początkowej fazie, co
        minimalizuje koszty napraw w przyszłości. Dodatkowo, pozytywny wynik
        przeglądu okresowego budynków może wpłynąć pozytywnie na wartość
        nieruchomości oraz na bezpieczeństwo użytkowników. Ważne jest również
        to, że <Link to="https://www.gunb.gov.pl/strona/kontrole-stanu-technicznego-obiektow" target="_blank">przegląd okresowy budynków jest wymagany przez prawo budowlane</Link> i
        jego wykonanie jest obowiązkowe.
      </p>
      <p>
        Jeśli potrzebujesz profesjonalnego przeglądu okresowego swojego budynku, 
        <Link to="/kontakt"> skontaktuj się z nami</Link>. Jesteśmy doświadczoną firmą z wieloletnim
        doświadczeniem w branży budowlanej. Nasza <Link to="/firma-nda">firma NDA</Link> oferuje pełen zakres
        usług budowlanych, w tym kierowanie budową, nadzór inwestorski oraz
        przeglądy okresowe budynków. Działamy na terenie województw
        zachodniopomorskiego i lubuskiego, a nasze <Link to="/#oferta">usługi kierujemy do klientów
        indywidualnych i przedsiębiorstw</Link>. Skontaktuj się z nami, a pomożemy Ci w
        realizacji Twoich planów budowlanych!
      </p>
    </CommonSeoPage>
  </Layout>
)

export default GuidePage
